import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  catalog: {
    data: null,
    timestamp: null,
    loading: false,
  },
  bookings: {
    data: null,
    timestamp: null,
    loading: false,
  },
  merch: {
    data: null,
    timestamp: null,
    loading: false,
  },
  connectors: {
    data: null,
    timestamp: null,
    loading: false,
  },
  calendars: {
    data: null,
    timestamp: null,
    loading: false,
  },
  works: {
    data: null,
    timestamp: null,
    loading: false,
  },
  tasks: {
    data: null,
    timestamp: null,
    loading: false,
  },
  approvals: {
    data: null,
    timestamp: null,
    loading: false,
  },
  sentApprovals: {
    data: null,
    timestamp: null,
    loading: false,
  },
  // Add more cache entries as needed
};

const dataCacheSlice = createSlice({
  name: 'dataCache',
  initialState,
  reducers: {
    setCacheData: (state, action) => {
      const { key, data } = action.payload;
      if (state[key]) {
        state[key].data = data;
        state[key].timestamp = Date.now();
        state[key].loading = false;
      }
    },
    setCacheLoading: (state, action) => {
      const { key, loading } = action.payload;
      if (state[key]) {
        state[key].loading = loading;
      }
    },
    clearCache: (state, action) => {
      const key = action.payload;
      if (key && state[key]) {
        state[key] = {
          data: null,
          timestamp: null,
          loading: false,
        };
      } else if (!key) {
        // Clear all cache
        Object.keys(state).forEach(k => {
          state[k] = {
            data: null,
            timestamp: null,
            loading: false,
          };
        });
      }
    },
    addCacheEntry: (state, action) => {
      const { key, initialData } = action.payload;
      if (!state[key]) {
        state[key] = {
          data: initialData || null,
          timestamp: Date.now(),
          loading: false,
        };
      }
    },
  },
});

export const { setCacheData, setCacheLoading, clearCache, addCacheEntry } = dataCacheSlice.actions;
export default dataCacheSlice.reducer;

